import { Adapter } from "@/core/models/adapter";
import { ResponseAdapter } from "@/core/models/response";

/**
 * Qui fait la reprise
 */
export const SELLER = "seller";
export const STORE = "store";
export const WAREHOUSE = "warehouse";

export class ItemDiagnostic {
  constructor() {
    this.id = null;
    this.diagnosticType = null;
    this.categoryId = null;
    this.categoryLabel = null;
    this.productId = null;
    this.productLabel = null;
    this.productBrand = null;
    this.productModele = null;
    this.productEanCode = null;
    this.productReference = null;
    this.productWeight = null;
    this.productLength = null;
    this.productWidth = null;
    this.productHeight = null;
    this.productState = null;
    this.diagnosticPrice = null;
    this.mainOrganizationId = null;
    this.mainOrganizationName = null;
    this.diagnosticianId = null;
    this.diagnosticianName = null;
    this.updatedBy = null;
    this.createdBy = null;
    this.createdAt = null;
    this.updatedAt = null;
    this.organizationId = null;
    this.imei = null;
    this.forcedInvalidImei = false;
    this.responses = [];
  }

  /**
   * @returns {string[]}
   */
  getResponseIds() {
    return this.responses.map((response) => response.responseId);
  }

  /**
   * @returns {boolean}
   */
  hasImei() {
    return !!this.imei;
  }

  /**
   * @returns {string}
   */
  getImei() {
    if (!this.hasImei()) {
      throw new Error("ItemDiagnostic has no imei, call hasImei() first.");
    }

    return this.imei;
  }
}

export class ItemDiagnosticAdapter extends Adapter {
  static adapt(itemDiagnosticApi) {
    const itemDiagnostic = new ItemDiagnostic();
    itemDiagnostic.id = itemDiagnosticApi?.id;
    itemDiagnostic.diagnosticType = itemDiagnosticApi?.diagnosticType;
    itemDiagnostic.categoryId = itemDiagnosticApi?.categoryId;
    itemDiagnostic.categoryLabel = itemDiagnosticApi?.categoryLabel;
    itemDiagnostic.productId = itemDiagnosticApi?.productId;
    itemDiagnostic.productLabel = itemDiagnosticApi?.productLabel;
    itemDiagnostic.productBrand = itemDiagnosticApi?.productBrand;
    itemDiagnostic.productModele = itemDiagnosticApi?.productModele;
    itemDiagnostic.productEanCode = itemDiagnosticApi?.productEanCode;
    itemDiagnostic.productReference = itemDiagnosticApi?.productReference;
    itemDiagnostic.productWeight = itemDiagnosticApi?.productWeight;
    itemDiagnostic.productLength = itemDiagnosticApi?.productLength;
    itemDiagnostic.productWidth = itemDiagnosticApi?.productWidth;
    itemDiagnostic.productHeight = itemDiagnosticApi?.productHeight;
    itemDiagnostic.productState = itemDiagnosticApi?.productState;
    itemDiagnostic.diagnosticPrice = itemDiagnosticApi?.diagnosticPrice;
    itemDiagnostic.mainOrganizationId = itemDiagnosticApi?.mainOrganizationId;
    itemDiagnostic.mainOrganizationName = itemDiagnosticApi?.mainOrganizationName;
    itemDiagnostic.diagnosticianId = itemDiagnosticApi?.diagnosticianId;
    itemDiagnostic.diagnosticianName = itemDiagnosticApi?.diagnosticianName;
    itemDiagnostic.updatedBy = itemDiagnosticApi?.updatedBy;
    itemDiagnostic.createdBy = itemDiagnosticApi?.createdBy;
    itemDiagnostic.createdAt = itemDiagnosticApi?.createdAt;
    itemDiagnostic.updatedAt = itemDiagnosticApi?.updatedAt;
    itemDiagnostic.organizationId = itemDiagnosticApi?.organizationId;
    itemDiagnostic.imei = itemDiagnosticApi?.imei;
    itemDiagnostic.forcedInvalidImei = itemDiagnosticApi?.forcedInvalidImei;

    return itemDiagnostic;
  }

  static adaptDeepItemDiagnostic(itemDiagnosticApi) {
    const itemDiagnostic = this.adapt(itemDiagnosticApi);

    if (itemDiagnosticApi.responses) {
      itemDiagnostic.responses = itemDiagnosticApi.responses.map((responseApi) => {
        return ResponseAdapter.adapt(responseApi);
      });
    }

    return itemDiagnostic;
  }
}
